export const CUSTOMER = 'CUSTOMER';
export const PROVIDER = 'PROVIDER';

export const conversationParticipantsTypes = [CUSTOMER, PROVIDER];
